import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { getInterestBusiness } from "../../../API/ApiService";
import {
  loadingAction,
  skeletonAction,
} from "../../../Redux/Action/loadingAction";
import { CATEGORY_BUSINESS } from "../../../Utils/constants";
import EmptyMessage from "../../../Component/EmptyMessage";
import InfinitScroll from "react-infinite-scroll-component";
import GridCardWrapper from "../../../Component/GridCardWrapper";
import Card from "../../../Component/Card";

const CategoryBusinesses = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [businessList, setBusinessList] = useState([]);
  let [isNext, isNextFunc] = useState(false);
  let [pageCount, setCount] = useState(1);
  const skeletonLoad = useSelector(
    (state) => state?.loadingReducers?.skeletonLoader
  );
  const user_uuid = localStorage.getItem("user_uuid");
  const PageSize = 20;

  useEffect(() => {
    fetchData();
  }, [pageCount, id]);

  const fetchData = () => {
    dispatch(skeletonAction(true, CATEGORY_BUSINESS));

    let body = {
      text: "",
      cat_id: id,
      user_uuid: user_uuid,
      page: pageCount,
      limit: PageSize,
      lat: localStorage.getItem("latitude") || 21.150058,
      lng: localStorage.getItem("longitude") || 72.8548533,
    };
    getInterestBusiness(body).then((res) => {
      if (res.status === 200) {
        dispatch(skeletonAction(false, CATEGORY_BUSINESS));
        if (pageCount === 1) {
          setBusinessList(res?.data?.result?.BusinessList);
        } else {
          setBusinessList((prevList) => [
            ...prevList,
            ...res?.data?.result?.BusinessList,
          ]);
        }
      }
      const totalRecords = res?.data?.result?.TotalRecords || 0;
      const totalPageCount = Math.ceil(totalRecords / PageSize);
      isNextFunc(pageCount < totalPageCount);
    });
  };

  const fetchMoreData = () => {
    dispatch(skeletonAction(false, CATEGORY_BUSINESS));
    setCount(pageCount + 1);
  };
  const businessPage = (id, b_name) => {
    navigate(
      `/businessDetails/${id}?name=${b_name?.trim()?.replaceAll(" ", "_")}`,
      { state: { id } }
    );
  };
  return (
    <div>
      <section className="green-heading">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>{location.state?.val.category_name} Businesses</h2>
            </div>
          </div>
        </div>
      </section>
      <section className="nib-boxes">
        <div className="container">
          <div className="row">
            {!skeletonLoad[CATEGORY_BUSINESS] && businessList?.length === 0 ? (
              <EmptyMessage
                message={`No Business found for the ${location.state?.val.category_name}`}
              />
            ) : (
              <>
                <InfinitScroll
                  dataLength={businessList?.length}
                  next={fetchMoreData}
                  //   hasMore={isNext}
                  style={{
                    overflow: "auto",
                    // height: "90vh"
                  }}
                >
                  <GridCardWrapper
                    blockWidth={310}
                    blockHeight={400}
                    isLoading={skeletonLoad[CATEGORY_BUSINESS]}
                    data={businessList}
                  >
                    {(props) => (
                      <Card
                        gridView
                        showAddress
                        showPhone
                        showReview
                        handleViewDetail={businessPage}
                        {...props}
                        width={300}
                        height={415}
                      />
                    )}
                  </GridCardWrapper>
                </InfinitScroll>
                {isNext && (
                  <div className="col-md-12 my-3 text-center">
                    <button className="view_more_btn" onClick={fetchMoreData}>
                      View More
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="for-border" />
      </section>
    </div>
  );
};

export default CategoryBusinesses;
